import { atom, useAtom } from "jotai";

const isVerifiedAtom = atom(false);
export const useTwoFactorAuthStatus = () => useAtom(isVerifiedAtom);
